import * as types from '../constants/ActionTypes';

export function show_stats_selector() {

    return {
        type: types.SHOW_STATS_SELECTOR
    };
}

export function close_stats_selector() {

    return {
        type: types.CLOSE_STATS_SELECTOR
    };
}

export function change_window_position(id, position){
    return {
        type: types.CHANGE_WINDOW_POSITION,
        id,
        position
    };
}

export function change_window_size(id, width, height){
    return {
        type: types.CHANGE_WINDOW_SIZE,
        id,
        width,
        height
    };
}

export function toggle_cut_down_window(id, isCutDown) {
        return {
            type: types.TOGGLE_CUT_DOWN_WINDOW,
            id,
            isCutDown
    };
}

export function show_stats_window(id) {
        return {
            type: types.SHOW_STATS_WINDOW,
            id
    };
}

export function close_stats_window(id) {
        return {
            type: types.CLOSE_STATS_WINDOW,
            id
    };
}

export function toggle_settings_window_visibility() {
    return {
        type: types.TOGGLE_SETTINGS_WINDOW
    };
}

export function toggle_about_window_visibility() {
    return {
        type: types.TOGGLE_ABOUT_WINDOW
    };
}

export function toggle_donate_window_visibility() {
    return {
        type: types.TOGGLE_DONATE_WINDOW
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/statisticActions.js
 **/